import axios from "axios";
import React, { Component } from "react";
import FormWrapper from "../styles/FormWrapper";
import { API_URL } from "../../config";

const UpdateUser = (props) => {
  const updateMyself = (data) =>
    axios({
      url: `${API_URL}/updateMyself`,
      method: "PUT",
      withCredentials: true,
      data,
    });
  return (
    <UpdateUserForm
      userData={props.userData}
      updateMyself={updateMyself}
      onOpen={props.onOpen}
      setmodalMessage={props.setmodalMessage}
      refetchUser={props.refetchUser}
    />
  );
};

export default UpdateUser;

class UpdateUserForm extends Component {
  state = {
    firstName: this.props.userData.firstName,
    lastName: this.props.userData.lastName,
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props
      .updateMyself({
        firstName: this.state.firstName,
        lastName: this.state.lastName,
      })
      .then(() => {
        this.props.setmodalMessage("Successfully updated name");
        this.props.onOpen();
      })
      .catch((error) => {
        console.log(error.response.data.message);
        this.props.setmodalMessage(error.response.data.message);
        this.props.onOpen();
      });
  };
  render() {
    return (
      <div className="componentWrapper">
        <h2>Change Name</h2>
        <FormWrapper onSubmit={this.handleSubmit}>
          <label>
            Email
            <div className="email">{this.props.userData.email}</div>
          </label>
          <label htmlFor="firstName">
            First name
            <input
              type="text"
              name="firstName"
              value={this.state.firstName}
              onChange={this.handleChange}
            />
          </label>
          <label htmlFor="lastName">
            Last name
            <input
              type="text"
              name="lastName"
              value={this.state.lastName}
              onChange={this.handleChange}
            />
          </label>
          <button type="submit">Update Name</button>
        </FormWrapper>
      </div>
    );
  }
}
